import React from 'react';
import {Helmet} from 'react-helmet';
import ContentWrapper from '../styles/ContentWrapper';

var Privacy = function () {
    return (
        <React.Fragment>
            <Helmet>
                <meta name='robots' content='noindex, nofollow' />
            </Helmet>
            <article role='article' about='/legal/privacy' typeof='schema:WebPage'>
                <span
                    property='schema:name'
                    content='Datenschutz'
                    className='stolo-hidden'
                />
                <ContentWrapper>
                    <div property='schema:text'><h1>Datenschutzerkl&auml;rung</h1>
                        <h2>1) Einleitung und Kontaktdaten des Verantwortlichen</h2>
                        <p><b>1.1</b>&nbsp;Wir freuen uns, dass du unsere Website besuchst
                            und bedanken uns f&uuml;r dein Interesse. Im Folgenden
                            informieren wir dich &uuml;ber den Umgang mit deinen
                            personenbezogenen Daten bei der Nutzung unserer Website.
                            Personenbezogene Daten sind hierbei alle Daten, mit denen du
                            pers&ouml;nlich identifiziert werden kannst.</p>
                        <p><b>1.2</b>&nbsp;Verantwortlicher f&uuml;r die Datenverarbeitung
                            auf dieser Website im Sinne der Datenschutz-Grundverordnung
                            (DSGVO) ist Becker &amp; Karsten UG (haftungsbeschr&auml;nkt),
                            Sandhauser Str. 107, 13505 Berlin, Deutschland, Tel.: +49 30
                            609851960, E-Mail: wir@beckerundkarsten.de. Der f&uuml;r die
                            Verarbeitung von personenbezogenen Daten Verantwortliche ist
                            diejenige nat&uuml;rliche oder juristische Person, die allein
                            oder gemeinsam mit anderen &uuml;ber die Zwecke und Mittel der
                            Verarbeitung von personenbezogenen Daten entscheidet.</p>
                        <h2>2) Datenerfassung beim Besuch unserer Website</h2>
                        <p><b>2.1</b>&nbsp;Bei der blo&szlig; informatorischen Nutzung
                            unserer Website, also wenn du dich nicht registrierst oder uns
                            anderweitig Informationen &uuml;bermittelst, erheben wir nur
                            solche Daten, die dein Browser an den
                            Seitenserver &uuml;bermittelt
                            (sog. &bdquo;Server-Logfiles&#8220;). Wenn du unsere Website
                            aufrufst, erheben wir die folgenden Daten, die f&uuml;r uns
                            technisch erforderlich sind, um dir die Website anzuzeigen:
                        </p>
                        <ul>
                            <li>Unsere besuchte Website</li>
                            <li>Datum und Uhrzeit zum Zeitpunkt des Zugriffs</li>
                            <li>Menge der gesendeten Daten in Byte</li>
                            <li>Quelle/Verweis, von welchem du auf die Seite gelangtest
                            </li>
                            <li>Verwendeter Browser</li>
                            <li>Verwendetes Betriebssystem</li>
                            <li>Verwendete IP-Adresse (ggf.: in anonymisierter Form)</li>
                        </ul>
                        <p>Die Verarbeitung erfolgt gem&auml;&szlig; Art. 6 Abs. 1 lit. f
                            DSGVO auf Basis unseres berechtigten Interesses an der
                            Verbesserung der Stabilit&auml;t und Funktionalit&auml;t
                            unserer Website. Eine Weitergabe oder anderweitige Verwendung
                            der Daten findet nicht statt. Wir behalten uns allerdings vor,
                            die Server-Logfiles nachtr&auml;glich zu &uuml;berpr&uuml;fen,
                            sollten konkrete Anhaltspunkte auf eine rechtswidrige Nutzung
                            hinweisen.</p>
                        <p><b>2.2</b>&nbsp;Diese Website nutzt aus Sicherheitsgr&uuml;nden
                            und zum Schutz der &Uuml;bertragung personenbezogener Daten
                            und anderer vertraulicher Inhalte (z.B. Bestellungen oder
                            Anfragen an uns) eine SSL-bzw. TLS-Verschl&uuml;sselung. Du
                            kannst eine verschl&uuml;sselte Verbindung an der
                            Zeichenfolge &bdquo;https://&#8220; und dem Schloss-Symbol in
                            deiner Browserzeile erkennen.</p>
                        <h2>3) Hosting &amp; Content-Delivery-Network</h2>
                        <p><b>3.1</b>&nbsp;Amazon Web Services</p>
                        <p>F&uuml;r das Hosting unserer Website und die Darstellung der
                            Seiteninhalte nutzen wir das System des folgenden Anbieters:
                            AWS EMEA SARL, 38 avenue John F. Kennedy, L-1855 Luxemburg</p>
                        <p>Daten k&ouml;nnen zudem &uuml;bermittelt werden an: Amazon Web
                            Services, Inc., 410 Terry Avenue North, Seattle, WA 98109,
                            USA</p>
                        <p>S&auml;mtliche auf unserer Website erhobenen Daten werden auf
                            den Servern des Anbieters verarbeitet. Wir haben mit dem
                            Anbieter einen Auftragsverarbeitungsvertrag geschlossen, der
                            den Schutz der Daten unserer Seitenbesucher sicherstellt und
                            eine unberechtigte Weitergabe an Dritte untersagt.</p>
                        <p>F&uuml;r Daten&uuml;bermittlungen in die USA hat sich der
                            Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy
                            Framework) angeschlossen, das auf Basis eines
                            Angemessenheitsbeschlusses der Europ&auml;ischen Kommission
                            die Einhaltung des europ&auml;ischen Datenschutzniveaus
                            sicherstellt.</p>
                        <p><b>3.2</b>&nbsp;Cloudflare</p>
                        <p>F&uuml;r das Hosting unserer Website und die Darstellung der
                            Seiteninhalte nutzen wir das System des folgenden Anbieters:
                            Cloudflare Inc., 101 Townsend St. San Francisco, CA 94107,
                            USA</p>
                        <p>S&auml;mtliche auf unserer Website erhobenen Daten werden auf
                            den Servern des Anbieters verarbeitet. Wir haben mit dem
                            Anbieter einen Auftragsverarbeitungsvertrag geschlossen, der
                            den Schutz der Daten unserer Seitenbesucher sicherstellt und
                            eine unberechtigte Weitergabe an Dritte untersagt.</p>
                        <p>F&uuml;r Daten&uuml;bermittlungen in die USA hat sich der
                            Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy
                            Framework) angeschlossen, das auf Basis eines
                            Angemessenheitsbeschlusses der Europ&auml;ischen Kommission
                            die Einhaltung des europ&auml;ischen Datenschutzniveaus
                            sicherstellt.</p>
                        <p><b>3.3</b>&nbsp;Shopify</p>
                        <p>F&uuml;r das Hosting unserer Website und die Darstellung der
                            Seiteninhalte nutzen wir das System des folgenden Anbieters:
                            Shopify International Limited, Victoria Buildings, 2. Etage,
                            1-2 Haddington Road, Dublin 4, D04 XN32, Irland
                            (&bdquo;Shopify&#8220;).</p>
                        <p>Daten werden zudem &uuml;bertragen an: Shopify Inc., 150 Elgin
                            St, Ottawa, ON K2P 1L4, Kanada.</p>
                        <p>S&auml;mtliche auf unserer Website erhobenen Daten werden auf
                            den Servern des Anbieters verarbeitet. Wir haben mit dem
                            Anbieter einen Auftragsverarbeitungsvertrag geschlossen, der
                            den Schutz der Daten unserer Seitenbesucher sicherstellt und
                            eine unberechtigte Weitergabe an Dritte untersagt.</p>
                        <p>Bei einer Daten&uuml;bermittlung nach Kanada ist ein
                            angemessenes Datenschutzniveau durch einen
                            Angemessenheitsbeschluss der Europ&auml;ischen Kommission
                            gew&auml;hrleistet.</p>
                        <p><b>3.4</b>&nbsp;AWS-CloudFront</p>
                        <p>Wir nutzen ein Content Delivery Network des folgenden
                            Anbieters: AWS EMEA SARL, 38 avenue John F. Kennedy, L-1855
                            Luxemburg</p>
                        <p>Dieser Dienst erm&ouml;glicht uns, gro&szlig;e Mediendateien
                            wie Grafiken, Seiteninhalte oder Skripte &uuml;ber ein Netz
                            regional verteilter Server schneller auszuliefern. Die
                            Verarbeitung erfolgt zur Wahrung unseres berechtigten
                            Interesses an der Verbesserung der Stabilit&auml;t und
                            Funktionalit&auml;t unserer Website gem. Art. 6 Abs. 1 lit. f
                            DSGVO.</p>
                        <p>Wir haben mit dem Anbieter einen Auftragsverarbeitungsvertrag
                            geschlossen, der den Schutz der Daten unserer Seitenbesucher
                            sicherstellt und eine unberechtigte Weitergabe an Dritte
                            untersagt.</p>
                        <p>Daten k&ouml;nnen zudem &uuml;bermittelt werden an: Amazon Web
                            Services, Inc., 410 Terry Avenue North, Seattle, WA 98109,
                            USA</p>
                        <p>F&uuml;r Daten&uuml;bermittlungen in die USA hat sich der
                            Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy
                            Framework) angeschlossen, das auf Basis eines
                            Angemessenheitsbeschlusses der Europ&auml;ischen Kommission
                            die Einhaltung des europ&auml;ischen Datenschutzniveaus
                            sicherstellt.</p>
                        <p><b>3.5</b>&nbsp;Cloudflare</p>
                        <p>Wir nutzen ein Content Delivery Network des folgenden
                            Anbieters: Cloudflare Inc., 101 Townsend St. San Francisco, CA
                            94107, USA</p>
                        <p>Dieser Dienst erm&ouml;glicht uns, gro&szlig;e Mediendateien
                            wie Grafiken, Seiteninhalte oder Skripte &uuml;ber ein Netz
                            regional verteilter Server schneller auszuliefern. Die
                            Verarbeitung erfolgt zur Wahrung unseres berechtigten
                            Interesses an der Verbesserung der Stabilit&auml;t und
                            Funktionalit&auml;t unserer Website gem. Art. 6 Abs. 1 lit. f
                            DSGVO. Wir haben mit dem Anbieter einen
                            Auftragsverarbeitungsvertrag geschlossen, der den Schutz der
                            Daten unserer Seitenbesucher sicherstellt und eine
                            unberechtigte Weitergabe an Dritte untersagt.</p>
                        <p>F&uuml;r Daten&uuml;bermittlungen in die USA hat sich der
                            Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy
                            Framework) angeschlossen, das auf Basis eines
                            Angemessenheitsbeschlusses der Europ&auml;ischen Kommission
                            die Einhaltung des europ&auml;ischen Datenschutzniveaus
                            sicherstellt.</p>
                        <p><b>3.6</b>&nbsp;Host Europe</p>
                        <p>Wir nutzen ein Content Delivery Network des folgenden
                            Anbieters: Host Europe GmbH, c/o WeWork, Friesenplatz 4, 50672
                            K&ouml;ln, Deutschland</p>
                        <p>Dieser Dienst erm&ouml;glicht uns, gro&szlig;e Mediendateien
                            wie Grafiken, Seiteninhalte oder Skripte &uuml;ber ein Netz
                            regional verteilter Server schneller auszuliefern. Die
                            Verarbeitung erfolgt zur Wahrung unseres berechtigten
                            Interesses an der Verbesserung der Stabilit&auml;t und
                            Funktionalit&auml;t unserer Website gem. Art. 6 Abs. 1 lit. f
                            DSGVO. Wir haben mit dem Anbieter einen
                            Auftragsverarbeitungsvertrag geschlossen, der den Schutz der
                            Daten unserer Seitenbesucher sicherstellt und eine
                            unberechtigte Weitergabe an Dritte untersagt.</p>
                        <p><b>3.7</b>&nbsp;Shopify</p>
                        <p>Wir nutzen ein Content Delivery Network des folgenden
                            Anbieters: Shopify International Limited, Victoria Buildings,
                            2. Etage, 1-2 Haddington Road, Dublin 4, D04 XN32, Irland
                            (&bdquo;Shopify&#8220;)</p>
                        <p>Daten k&ouml;nnen zudem &uuml;bertragen werden an:</p>
                        <ul>
                            <li>Shopify Inc., 150 Elgin St, Ottawa, ON K2P 1L4, Kanada
                            </li>
                            <li>Cloudflare Inc., 101 Townsend St. San Francisco, CA 94107,
                                USA
                            </li>
                        </ul>
                        <p>Dieser Dienst erm&ouml;glicht uns, gro&szlig;e Mediendateien
                            wie Grafiken, Seiteninhalte oder Skripte &uuml;ber ein Netz
                            regional verteilter Server schneller auszuliefern. Die
                            Verarbeitung erfolgt zur Wahrung unseres berechtigten
                            Interesses an der Verbesserung der Stabilit&auml;t und
                            Funktionalit&auml;t unserer Website gem. Art. 6 Abs. 1 lit. f
                            DSGVO. Wir haben mit dem Anbieter einen
                            Auftragsverarbeitungsvertrag geschlossen, der den Schutz der
                            Daten unserer Seitenbesucher sicherstellt und eine
                            unberechtigte Weitergabe an Dritte untersagt.</p>
                        <p>Bei einer Daten&uuml;bermittlung nach Kanada ist ein
                            angemessenes Datenschutzniveau durch einen
                            Angemessenheitsbeschluss der Europ&auml;ischen Kommission
                            gew&auml;hrleistet.</p>
                        <p>F&uuml;r Daten&uuml;bermittlungen in die USA hat sich der
                            Datenempf&auml;nger dem EU-US-Datenschutzrahmen (EU-US Data
                            Privacy Framework) angeschlossen, das auf Basis eines
                            Angemessenheitsbeschlusses der Europ&auml;ischen Kommission
                            die Einhaltung des europ&auml;ischen Datenschutzniveaus
                            sicherstellt.</p>
                        <h2>4) Cookies</h2>
                        <p>Um den Besuch unserer Website attraktiv zu gestalten und die
                            Nutzung bestimmter Funktionen zu erm&ouml;glichen, verwenden
                            wir Cookies, also kleine Textdateien, die auf deinem
                            Endger&auml;t abgelegt werden. Teilweise werden diese Cookies
                            nach Schlie&szlig;en des Browsers automatisch wieder
                            gel&ouml;scht (sog. &bdquo;Session-Cookies&#8220;), teilweise
                            verbleiben diese Cookies l&auml;nger auf deinem Endger&auml;t
                            und erm&ouml;glichen das Speichern von Seiteneinstellungen
                            (sog. &bdquo;persistente Cookies&#8220;). Im letzteren Fall
                            kannst du die Speicherdauer der &Uuml;bersicht zu den
                            Cookie-Einstellungen deines Webbrowsers entnehmen.</p>
                        <p>Sofern durch einzelne von uns eingesetzte Cookies auch
                            personenbezogene Daten verarbeitet werden, erfolgt die
                            Verarbeitung gem&auml;&szlig; Art. 6 Abs. 1 lit. b DSGVO
                            entweder zur Durchf&uuml;hrung des Vertrages,
                            gem&auml;&szlig; Art. 6 Abs. 1 lit. a DSGVO im Falle einer
                            erteilten Einwilligung oder gem&auml;&szlig; Art. 6 Abs. 1
                            lit. f DSGVO zur Wahrung unserer berechtigten Interessen an
                            der bestm&ouml;glichen Funktionalit&auml;t der Website sowie
                            einer kundenfreundlichen und effektiven Ausgestaltung des
                            Seitenbesuchs.</p>
                        <p>Du kannst deinen Browser so einstellen, dass du &uuml;ber das
                            Setzen von Cookies informiert wirst und einzeln &uuml;ber
                            deren Annahme entscheiden oder die Annahme von Cookies
                            f&uuml;r bestimmte F&auml;lle oder generell ausschlie&szlig;en
                            kannst.</p>
                        <p>Bitte beachte, dass bei Nichtannahme von Cookies die
                            Funktionalit&auml;t unserer Website eingeschr&auml;nkt sein
                            kann.</p>
                        <h2>5) Kontaktaufnahme</h2>
                        <p><b>5.1</b>&nbsp;WhatsApp-Business</p>
                        <p>Wir bieten dir die M&ouml;glichkeit, mit uns &uuml;ber den
                            Nachrichtendienst WhatsApp der WhatsApp Ireland Limited, 4
                            Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland, in
                            Kontakt zu treten. Hierf&uuml;r verwenden wir die
                            sog. &bdquo;Business-Version&#8220; von WhatsApp.</p>
                        <p>Sofern du uns anl&auml;sslich eines konkreten Gesch&auml;fts
                            (beispielsweise einer get&auml;tigten Bestellung) per WhatsApp
                            kontaktierst, speichern und verwenden wir die von dir bei
                            WhatsApp genutzte Mobilfunknummer sowie &ndash; falls
                            bereitgestellt &ndash; deinen Vor- und Nachnamen
                            gem&auml;&szlig; Art. 6 Abs. 1 lit. b. DSGVO zur Bearbeitung
                            und Beantwortung deines Anliegens. Auf Basis derselben
                            Rechtsgrundlage werden wir dich per WhatsApp gegebenenfalls um
                            die Bereitstellung weiterer Daten (Bestellnummer,
                            Kundennummer, Anschrift oder E-Mailadresse) bitten, um deine
                            Anfrage einem bestimmten Vorgang zuordnen zu k&ouml;nnen.</p>
                        <p>Nutzt Du unseren WhatsApp-Kontakt f&uuml;r allgemeine Anfragen
                            (etwa zum Leistungsspektrum, zu Verf&uuml;gbarkeiten oder zu
                            unserem Internetauftritt) speichern und verwenden wir die von
                            dir bei WhatsApp genutzte Mobilfunknummer sowie &ndash; falls
                            bereitgestellt &ndash; deinen Vor- und Nachnamen
                            gem&auml;&szlig; Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres
                            berechtigten Interesses an der effizienten und zeitnahen
                            Bereitstellung der gew&uuml;nschten Informationen.</p>
                        <p>Deine Daten werden stets nur zur Beantwortung deines Anliegens
                            per WhatsApp verwendet. Eine Weitergabe an Dritte findet nicht
                            statt.</p>
                        <p>Bitte beachte, dass WhatsApp Business Zugriff auf das
                            Adressbuch des von uns hierf&uuml;r verwendeten mobilen
                            Endger&auml;ts erh&auml;lt und im Adressbuch gespeicherte
                            Telefonnummern automatisch an einen Server des Mutterkonzerns
                            Meta Platforms Inc. in den USA &uuml;bertr&auml;gt. F&uuml;r
                            den Betrieb unseres WhatsApp-Business-Kontos verwenden wir ein
                            mobiles Endger&auml;t, in dessen Adressbuch
                            ausschlie&szlig;lich die WhatsApp-Kontaktdaten solcher Nutzer
                            gespeichert werden, die mit uns per WhatsApp auch in Kontakt
                            getreten sind.</p>
                        <p>Hierdurch wird sichergestellt, dass jede Person, deren
                            WhatsApp-Kontaktdaten in unserem Adressbuch gespeichert sind,
                            bereits bei erstmaliger Nutzung der App auf seinem Ger&auml;t
                            durch Akzeptanz der WhatsApp-Nutzungsbedingungen in
                            die &Uuml;bermittlung seiner WhatsApp-Telefonnummer aus den
                            Adressb&uuml;chern seiner Chat-Kontakte gem&auml;&szlig; Art.
                            6 Abs. 1 lit. a DSGVO eingewilligt hat. Eine &Uuml;bermittlung
                            von Daten solcher Nutzer, die WhatsApp nicht verwenden
                            und/oder uns nicht &uuml;ber WhatsApp kontaktiert haben, wird
                            insofern ausgeschlossen.</p>
                        <p>Zweck und Umfang der Datenerhebung und die weitere Verarbeitung
                            und Nutzung der Daten durch WhatsApp sowie deine
                            diesbez&uuml;glichen Rechte und Einstellungsm&ouml;glichkeiten
                            zum Schutz deiner Privatsph&auml;re entnimmst Du bitte den
                            Datenschutzhinweisen von WhatsApp: <a
                              href="https://www.whatsapp.com/legal/?eea=1#privacy-policy"
                              target="_blank">https://www.whatsapp.com
                                <wbr/>
                                /legal
                                <wbr/>
                                /?eea=1#privacy-policy</a></p>
                        <p>Im Rahmen der oben genannten Verarbeitungen kann es zu
                            Daten&uuml;bertragungen an Server von Meta Platforms Inc. in
                            den USA kommen.</p>
                        <p>F&uuml;r Daten&uuml;bermittlungen in die USA hat sich der
                            Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy
                            Framework) angeschlossen, das auf Basis eines
                            Angemessenheitsbeschlusses der Europ&auml;ischen Kommission
                            die Einhaltung des europ&auml;ischen Datenschutzniveaus
                            sicherstellt.</p>
                        <p><b>5.2</b>&nbsp;Im Rahmen der Kontaktaufnahme mit uns (z.B. per
                            Kontaktformular oder E-Mail)
                            werden &ndash; ausschlie&szlig;lich zum Zweck der Bearbeitung
                            und Beantwortung deines Anliegens und nur im daf&uuml;r
                            erforderlichen Umfang &ndash; personenbezogene Daten
                            verarbeitet.</p>
                        <p>Rechtsgrundlage f&uuml;r die Verarbeitung dieser Daten ist
                            unser berechtigtes Interesse an der Beantwortung deines
                            Anliegens gem&auml;&szlig; Art. 6 Abs. 1 lit. f DSGVO. Zielt
                            deine Kontaktierung auf einen Vertrag ab, so ist
                            zus&auml;tzliche Rechtsgrundlage f&uuml;r die Verarbeitung
                            Art. 6 Abs. 1 lit. b DSGVO. Deine Daten werden gel&ouml;scht,
                            wenn sich aus den Umst&auml;nden entnehmen l&auml;sst, dass
                            der betroffene Sachverhalt abschlie&szlig;end gekl&auml;rt ist
                            und sofern keine gesetzlichen Aufbewahrungspflichten
                            entgegenstehen.</p>
                        <h2>6) Kommentarfunktion</h2>
                        <p>Im Rahmen der Kommentarfunktion auf dieser Website werden neben
                            deinem Kommentar auch Angaben zum Zeitpunkt der Erstellung des
                            Kommentars und der von dir gew&auml;hlte Kommentatorenname
                            gespeichert und auf dieser Website ver&ouml;ffentlicht. Ferner
                            wird deine IP-Adresse mitprotokolliert und gespeichert. Diese
                            Speicherung der IP-Adresse erfolgt aus Sicherheitsgr&uuml;nden
                            und f&uuml;r den Fall, dass du durch einen abgegebenen
                            Kommentar die Rechte Dritter verletzt oder rechtswidrige
                            Inhalte postest. Deine E-Mailadresse ben&ouml;tigen wir, um
                            mit dir in Kontakt zu treten, falls ein Dritter deinen
                            ver&ouml;ffentlichten Inhalt als rechtswidrig beanstanden
                            sollte.</p>
                        <p>Rechtsgrundlagen f&uuml;r die Speicherung deiner Daten sind die
                            Art. 6 Abs. 1 lit. b und f DSGVO. Wir behalten uns vor,
                            Kommentare zu l&ouml;schen, wenn sie von Dritten als
                            rechtswidrig beanstandet werden.</p>
                        <p>Die Nachfolgekommentare kannst du als Nutzer abonnieren. Du
                            erh&auml;ltst hierzu eine Best&auml;tigungs-E-Mail, damit
                            sichergestellt werden kann, dass du der Inhaber der
                            angegebenen E-Mail-Adresse bist (Double-Opt-In-Verfahren). Die
                            Rechtsgrundlage f&uuml;r die Datenverarbeitung im Falle der
                            Abonnierung von Kommentaren ist Art. 6 Abs. 1 lit. a DSGVO. Du
                            kannst laufende Kommentarabonnements jederzeit mit Wirkung
                            f&uuml;r die Zukunft abbestellen, n&auml;here Informationen
                            zur Abbestellm&ouml;glichkeit entnimm bitte der
                            Best&auml;tigungs-E-Mail.</p>
                        <h2>7) Datenverarbeitung bei Er&ouml;ffnung eines
                            Kundenkontos</h2>
                        <p>Gem&auml;&szlig; Art. 6 Abs. 1 lit. b DSGVO werden
                            personenbezogene Daten im jeweils erforderlichen Umfang
                            weiterhin erhoben und verarbeitet, wenn du uns diese bei der
                            Er&ouml;ffnung eines Kundenkontos mitteilst. Welche Daten
                            f&uuml;r die Kontoer&ouml;ffnung erforderlich sind, entnimmst
                            du der Eingabemaske des entsprechenden Formulars auf unserer
                            Website.</p>
                        <p>Eine L&ouml;schung deines Kundenkontos ist jederzeit
                            m&ouml;glich und kann durch eine Nachricht an die o.g. Adresse
                            des Verantwortlichen erfolgen. Nach L&ouml;schung deines
                            Kundenkontos werden deine Daten gel&ouml;scht, sofern alle
                            dar&uuml;ber geschlossenen Vertr&auml;ge vollst&auml;ndig
                            abgewickelt sind, keine gesetzlichen Aufbewahrungsfristen
                            entgegenstehen und unsererseits kein berechtigtes Interesse an
                            der Weiterspeicherung fortbesteht.</p>
                        <h2>8) Nutzung von Kundendaten zur Direktwerbung</h2>
                        <p><b>8.1</b>&nbsp;Anmeldung zu unserem E-Mail-Newsletter</p>
                        <p>Wenn du dich zu unserem E-Mail Newsletter
                            anmeldest, &uuml;bersenden wir dir regelm&auml;&szlig;ig
                            Informationen zu unseren Angeboten. Pflichtangabe f&uuml;r
                            die &Uuml;bersendung des Newsletters ist allein deine
                            E-Mailadresse. Die Angabe weiterer Daten ist freiwillig und
                            wird verwendet, um dich pers&ouml;nlich ansprechen zu
                            k&ouml;nnen. F&uuml;r den Newsletter-Versand verwenden wir das
                            sog. Double Opt-in Verfahren, mit dem sichergestellt wird,
                            dass du Newsletter erst erh&auml;ltst, wenn du uns durch
                            Bet&auml;tigung eines an die angegebene Mailadresse versandten
                            Verifizierungslinks ausdr&uuml;cklich deine Einwilligung in
                            den Newsletterempfang best&auml;tigt hast.</p>
                        <p>Mit der Aktivierung des Best&auml;tigungslinks erteilst du uns
                            deine Einwilligung f&uuml;r die Nutzung deiner
                            personenbezogenen Daten gem&auml;&szlig; Art. 6 Abs. 1 lit. a
                            DSGVO. Hierbei speichern wir deine vom Internet
                            Service-Provider (ISP) eingetragene IP-Adresse sowie das Datum
                            und die Uhrzeit der Anmeldung, um einen m&ouml;glichen
                            Missbrauch deiner E-Mail-Adresse zu einem sp&auml;teren
                            Zeitpunkt nachvollziehen zu k&ouml;nnen. Die von uns bei der
                            Anmeldung zum Newsletter erhobenen Daten werden streng
                            zweckgebunden verwendet.</p>
                        <p>Du kannst den Newsletter jederzeit &uuml;ber den daf&uuml;r
                            vorgesehenen Link im Newsletter oder durch entsprechende
                            Nachricht an den eingangs genannten Verantwortlichen
                            abbestellen. Nach erfolgter Abmeldung wird deine E-Mailadresse
                            unverz&uuml;glich in unserem Newsletter-Verteiler
                            gel&ouml;scht, soweit du nicht ausdr&uuml;cklich in eine
                            weitere Nutzung deiner Daten eingewilligt hast oder wir uns
                            eine dar&uuml;berhinausgehende Datenverwendung vorbehalten,
                            die gesetzlich erlaubt ist und &uuml;ber die wir dich in
                            dieser Erkl&auml;rung informieren.</p>
                        <p><b>8.2</b>&nbsp;MailChimp</p>
                        <p>Der Versand unserer E-Mail-Newsletter erfolgt &uuml;ber diesen
                            Anbieter: The Rocket Science Group, LLC d/b/a MailChimp, 675
                            Ponce de Leon Ave NE, Suite 5000, Atlanta, GA 30308, USA.</p>
                        <p>Auf Basis unseres berechtigten Interesses an einem effektiven
                            und nutzerfreundlichen Newsletter-Marketing geben wir deine
                            bei der Newsletter-Anmeldung bereitgestellten Daten gem. Art.
                            6 Abs. 1 lit. f DSGVO an diesen Anbieter weiter, damit dieser
                            den Newsletterversand in unserem Auftrag &uuml;bernimmt.</p>
                        <p>Vorbehaltlich deiner ausdr&uuml;cklichen Einwilligung gem. Art.
                            6 Abs. 1 lit. a DSGVO f&uuml;hrt der Anbieter dar&uuml;ber
                            hinaus eine statistische Erfolgsauswertung von
                            Newsletter-Kampagnen mittels Web Beacons bzw. Z&auml;hlpixel
                            in den versendeten E-Mails durch, die &Ouml;ffnungsraten und
                            spezifische Interaktionen mit den Inhalten des Newsletters
                            messen k&ouml;nnen. Dabei werden auch
                            Endger&auml;teinformationen (z.B. Zeitpunkt des Aufrufs,
                            IP-Adresse, Browsertyp und Betriebssystem) erhoben und
                            ausgewertet, aber nicht mit anderen Datenbest&auml;nden
                            zusammengef&uuml;hrt.</p>
                        <p>Deine Einwilligung zum Newsletter-Tracking kannst du jederzeit
                            mit Wirkung f&uuml;r die Zukunft widerrufen.</p>
                        <p>Wir haben mit dem Anbieter einen Auftragsverarbeitungsvertrag
                            geschlossen, der die Daten unserer Seitenbesucher sch&uuml;tzt
                            und eine Weitergabe an Dritte untersagt.</p>
                        <p>F&uuml;r Daten&uuml;bermittlungen in die USA hat sich der
                            Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy
                            Framework) angeschlossen, das auf Basis eines
                            Angemessenheitsbeschlusses der Europ&auml;ischen Kommission
                            die Einhaltung des europ&auml;ischen Datenschutzniveaus
                            sicherstellt.</p>
                        <h2>9) Datenverarbeitung zur Bestellabwicklung</h2>
                        <p><b>9.1</b>&nbsp;&Uuml;bermittlung von Bilddateien zur
                            Bestellabwicklung per E-Mail</p>
                        <p>Auf unserer Website bieten wir dir die M&ouml;glichkeit, durch
                            die &Uuml;bermittlung von Bilddateien per E-Mail die
                            Personalisierung von Produkten zu beauftragen. Dabei wird das
                            eingereichte Bildmotiv als Vorlage f&uuml;r die
                            Personalisierung des gew&auml;hlten Produktes verwendet.</p>
                        <p>&Uuml;ber die auf der Website mitgeteilte Mailadresse kannst du
                            eine oder mehrere Bilddateien aus dem Speicher des verwendeten
                            Endger&auml;tes an uns &uuml;bermitteln. Wir erfassen,
                            speichern und verwenden die so &uuml;bermittelten Dateien
                            daraufhin ausschlie&szlig;lich zur Anfertigung des
                            personalisierten Produktes im Sinne der jeweiligen
                            Leistungsbeschreibung auf unserer Website. Sofern
                            die &uuml;bermittelten Bilddateien zur Anfertigung und
                            Abwicklung der Bestellung an spezielle Dienstleister
                            weitergegeben werden, wirst du hier&uuml;ber in den folgenden
                            Abs&auml;tzen explizit informiert. Eine
                            dar&uuml;berhinausgehende Weitergabe erfolgt nicht. Sofern
                            die &uuml;bermittelten Dateien bzw. die digitalen Motive
                            personenbezogene Daten (insbesondere Abbildungen von
                            identifizierbaren Personen) enthalten, erfolgen s&auml;mtliche
                            soeben benannten Verarbeitungsvorg&auml;nge
                            ausschlie&szlig;lich zum Zwecke der Abwicklung deiner
                            Online-Bestellung gem&auml;&szlig; Art. 6 Abs. 1 lit. b
                            DSGVO.</p>
                        <p>Nach abschlie&szlig;ender Abwicklung der Bestellung werden
                            die &uuml;bermittelten Bilddateien automatisch und
                            vollst&auml;ndig gel&ouml;scht.</p>
                        <p><b>9.2</b>&nbsp;&Uuml;bermittlung von Bilddateien zur
                            Bestellabwicklung per Upload-Funktion</p>
                        <p>Auf unserer Website bieten wir dir die M&ouml;glichkeit, durch
                            die &Uuml;bermittlung von Bilddateien &uuml;ber eine
                            Upload-Funktion die Personalisierung von Produkten zu
                            beauftragen. Dabei wird das eingereichte Bildmotiv als Vorlage
                            f&uuml;r die Personalisierung des gew&auml;hlten Produktes
                            verwendet.</p>
                        <p>&Uuml;ber das Upload-Formular auf der Website kannst du eine
                            oder mehrere Bilddateien aus dem Speicher deines verwendeten
                            Endger&auml;tes unmittelbar per automatisierter,
                            verschl&uuml;sselter Daten&uuml;bertragung an
                            uns &uuml;bermitteln. Wir erfassen, speichern und verwenden
                            die &uuml;bermittelten Dateien daraufhin ausschlie&szlig;lich
                            zur Anfertigung des personalisierten Produktes im Sinne der
                            jeweiligen Leistungsbeschreibung auf unserer Website. Sofern
                            die &uuml;bermittelten Bilddateien zur Anfertigung und
                            Abwicklung der Bestellung an spezielle Dienstleister
                            weitergegeben werden, wirst du hier&uuml;ber in den folgenden
                            Abs&auml;tzen explizit informiert. Eine
                            dar&uuml;berhinausgehende Weitergabe erfolgt nicht. Sofern
                            die &uuml;bermittelten Dateien bzw. die digitalen Motive
                            personenbezogene Daten (insbesondere Abbildungen von
                            identifizierbaren Personen) enthalten, erfolgen s&auml;mtliche
                            soeben benannten Verarbeitungsvorg&auml;nge
                            ausschlie&szlig;lich zum Zwecke der Abwicklung deiner
                            Online-Bestellung gem&auml;&szlig; Art. 6 Abs. 1 lit. b
                            DSGVO.</p>
                        <p>Nach abschlie&szlig;ender Abwicklung der Bestellung werden
                            die &uuml;bermittelten Bilddateien automatisch und
                            vollst&auml;ndig gel&ouml;scht.</p>
                        <p><b>9.3</b>&nbsp;Soweit f&uuml;r die Vertragsabwicklung zu
                            Liefer- und Zahlungszwecken erforderlich, werden die von uns
                            erhobenen personenbezogenen Daten gem&auml;&szlig; Art. 6 Abs.
                            1 lit. b DSGVO an das beauftragte Transportunternehmen und das
                            beauftragte Kreditinstitut weitergegeben.</p>
                        <p>Sofern wir Dir auf Grundlage eines entsprechenden Vertrages
                            Aktualisierungen f&uuml;r Waren mit digitalen Elementen oder
                            f&uuml;r digitale Produkte schulden, verarbeiten wir die von
                            Dir bei der Bestellung &uuml;bermittelten Kontaktdaten (Name,
                            Anschrift, Mailadresse), um Dich im Rahmen unserer
                            gesetzlichen Informationspflichten gem&auml;&szlig; Art. 6
                            Abs. 1 lit. c DSGVO auf geeignetem Kommunikationsweg (etwa
                            postalisch oder per Mail) &uuml;ber anstehende
                            Aktualisierungen im gesetzlich vorgesehenen Zeitraum
                            pers&ouml;nlich zu informieren. Deine Kontaktdaten werden
                            hierbei streng zweckgebunden f&uuml;r Mitteilungen &uuml;ber
                            von uns geschuldete Aktualisierungen verwendet und zu diesem
                            Zweck durch uns nur insoweit verarbeitet, wie dies f&uuml;r
                            die jeweilige Information erforderlich ist.</p>
                        <p>Zur Abwicklung Deiner Bestellung arbeiten wir ferner mit dem /
                            den nachstehenden Dienstleister(n) zusammen, die uns ganz oder
                            teilweise bei der Durchf&uuml;hrung geschlossener
                            Vertr&auml;ge unterst&uuml;tzen. An diese Dienstleister werden
                            nach Ma&szlig;gabe der folgenden Informationen gewisse
                            personenbezogene Daten &uuml;bermittelt.</p>
                        <p><b>9.4</b>&nbsp;Billbee</p>
                        <p>F&uuml;r die Bestellabwicklung nutzen wir den folgenden
                            Anbieter: Billbee GmbH, Arolser Str. 10, 34477 Twistetal</p>
                        <p>Name, Anschrift sowie gegebenenfalls weitere personenbezogene
                            Daten werden gem&auml;&szlig; Art. 6 Abs. 1 lit. b DSGVO
                            ausschlie&szlig;lich zum Zwecke der Abwicklung deiner
                            Online-Bestellung an den Anbieter weitergegeben. Die
                            Weitergabe deiner Daten erfolgt hierbei nur, soweit dies
                            f&uuml;r die Abwicklung der Bestellung tats&auml;chlich
                            erforderlich ist.</p>
                        <p><b>9.5</b>&nbsp;Shopify Digital Download</p>
                        <p>F&uuml;r die Bestellabwicklung nutzen wir den folgenden
                            Anbieter: Shopify International Limited, Victoria Buildings,
                            2. Etage, 1-2 Haddington Road, Dublin 4, D04 XN32, Irland</p>
                        <p>Name, Anschrift sowie gegebenenfalls weitere personenbezogene
                            Daten werden gem&auml;&szlig; Art. 6 Abs. 1 lit. b DSGVO
                            ausschlie&szlig;lich zum Zwecke der Abwicklung der
                            Online-Bestellung an den Anbieter weitergegeben. Die
                            Weitergabe deiner Daten erfolgt hierbei nur, soweit dies
                            f&uuml;r die Abwicklung der Bestellung tats&auml;chlich
                            erforderlich ist.</p>
                        <p><b>9.6</b>&nbsp;Weitergabe personenbezogener Daten an
                            Versanddienstleister</p>
                        <p>- Deutsche Post</p>
                        <p>Als Transportdienstleister nutzen wir den nachstehenden
                            Anbieter: Deutsche Post AG, Charles-de-Gaulle-Stra&szlig;e 20,
                            53113 Bonn, Deutschland</p>
                        <p>Wir geben deine E-Mail-Adresse und/oder Telefonnummer
                            gem&auml;&szlig; Art. 6 Abs. 1 lit. a DSGVO vor der Zustellung
                            der Ware zum Zweck der Abstimmung eines Liefertermins bzw. zur
                            Lieferank&uuml;ndigung an den Anbieter weiter, sofern du
                            hierf&uuml;r im Bestellprozess deine ausdr&uuml;ckliche
                            Einwilligung erteilt hast. Anderenfalls geben wir zum Zwecke
                            der Zustellung gem&auml;&szlig; Art. 6 Abs. 1 lit. b DSGVO nur
                            den Namen des Empf&auml;ngers und die Lieferadresse an den
                            Anbieter weiter. Die Weitergabe erfolgt nur, soweit dies
                            f&uuml;r die Warenlieferung erforderlich ist. In diesem Fall
                            ist eine vorherige Abstimmung des Liefertermins mit dem
                            Anbieter bzw. die Lieferank&uuml;ndigung nicht
                            m&ouml;glich.</p>
                        <p>Die Einwilligung kann jederzeit mit Wirkung f&uuml;r die
                            Zukunft gegen&uuml;ber dem oben bezeichneten Verantwortlichen
                            oder gegen&uuml;ber dem Anbieter widerrufen werden.<br/>
                            - DHL</p>
                        <p>Als Transportdienstleister nutzen wir den nachstehenden
                            Anbieter: DHL Paket GmbH, Str&auml;&szlig;chensweg 10, 53113
                            Bonn, Deutschland</p>
                        <p>Wir geben deine E-Mail-Adresse und/oder Telefonnummer
                            gem&auml;&szlig; Art. 6 Abs. 1 lit. a DSGVO vor der Zustellung
                            der Ware zum Zweck der Abstimmung eines Liefertermins bzw. zur
                            Lieferank&uuml;ndigung an den Anbieter weiter, sofern du
                            hierf&uuml;r im Bestellprozess deine ausdr&uuml;ckliche
                            Einwilligung erteilt hast. Anderenfalls geben wir zum Zwecke
                            der Zustellung gem&auml;&szlig; Art. 6 Abs. 1 lit. b DSGVO nur
                            den Namen des Empf&auml;ngers und die Lieferadresse an den
                            Anbieter weiter. Die Weitergabe erfolgt nur, soweit dies
                            f&uuml;r die Warenlieferung erforderlich ist. In diesem Fall
                            ist eine vorherige Abstimmung des Liefertermins mit dem
                            Anbieter bzw. die Lieferank&uuml;ndigung nicht
                            m&ouml;glich.</p>
                        <p>Die Einwilligung kann jederzeit mit Wirkung f&uuml;r die
                            Zukunft gegen&uuml;ber dem oben bezeichneten Verantwortlichen
                            oder gegen&uuml;ber dem Anbieter widerrufen werden.</p>
                        <p><b>9.7</b>&nbsp;Verwendung von Paymentdienstleistern
                            (Zahlungsdiensten)</p>
                        <p>- Paypal</p>
                        <p>Auf dieser Website stehen eine oder mehrere
                            Online-Zahlungsarten des folgenden Anbieters zur
                            Verf&uuml;gung: PayPal (Europe) S.a.r.l. et Cie, S.C.A., 22-24
                            Boulevard Royal, L-2449 Luxemburg</p>
                        <p>Bei Auswahl einer Zahlungsart des Anbieters, bei der du in
                            Vorleistung gehst, werden an diesen deine im Rahmen des
                            Bestellvorgangs mitgeteilten Zahlungsdaten (darunter Name,
                            Anschrift, Bank- und Zahlkarteninformationen, W&auml;hrung und
                            Transaktionsnummer) sowie Informationen &uuml;ber den Inhalt
                            deiner Bestellung gem&auml;&szlig; Art. 6 Abs. 1 lit. b DSGVO
                            weitergegeben. Die Weitergabe deiner Daten erfolgt in diesem
                            Falle ausschlie&szlig;lich zum Zweck der Zahlungsabwicklung
                            mit dem Anbieter und nur insoweit, als sie hierf&uuml;r
                            erforderlich ist.</p>
                        <p>Bei Auswahl einer Zahlungsart, bei der wir in Vorleistung
                            gehen, wirst du im Bestellablauf auch aufgefordert, bestimmte
                            pers&ouml;nliche Daten (Vor- und Nachname, Stra&szlig;e,
                            Hausnummer, Postleitzahl, Ort, Geburtsdatum, E-Mail-Adresse,
                            Telefonnummer, ggf. Daten zu einem alternativen
                            Zahlungsmittel) anzugeben.</p>
                        <p>Um in solchen F&auml;llen unser berechtigtes Interesse an der
                            Feststellung deiner Zahlungsf&auml;higkeit zu wahren, werden
                            diese Daten von uns gem&auml;&szlig; Art. 6 Abs. 1 lit. f
                            DSGVO zum Zwecke einer Bonit&auml;tspr&uuml;fung an den
                            Anbieter weitergeleitet. Der Anbieter pr&uuml;ft auf Basis der
                            von dir angegebenen pers&ouml;nlichen Daten sowie weiterer
                            Daten (wie etwa Warenkorb, Rechnungsbetrag, Bestellhistorie,
                            Zahlungserfahrungen), ob die von dir ausgew&auml;hlte
                            Zahlungsm&ouml;glichkeit im Hinblick auf Zahlungs- und/oder
                            Forderungsausfallrisiken gew&auml;hrt werden kann.</p>
                        <p>Die Bonit&auml;tsauskunft kann Wahrscheinlichkeitswerte
                            enthalten (sog. Score-Werte). Soweit Score-Werte in das
                            Ergebnis der Bonit&auml;tsauskunft einflie&szlig;en, haben sie
                            ihre Grundlage in einem wissenschaftlich anerkannten
                            mathematisch-statistischen Verfahren. In die Berechnung der
                            Score-Werte flie&szlig;en unter anderem, aber nicht
                            ausschlie&szlig;lich, Anschriftendaten ein.</p>
                        <p>Du kannst dieser Verarbeitung deiner Daten jederzeit durch eine
                            Nachricht an uns oder gegen&uuml;ber dem Anbieter
                            widersprechen. Jedoch bleibt der Anbieter ggf. weiterhin
                            berechtigt, deine personenbezogenen Daten zu verarbeiten,
                            sofern dies zur vertragsgem&auml;&szlig;en Zahlungsabwicklung
                            erforderlich ist.<br/>
                            - Stripe</p>
                        <p>Auf dieser Website stehen eine oder mehrere
                            Online-Zahlungsarten des folgenden Anbieters zur
                            Verf&uuml;gung: Stripe Payments Europe Ltd., 1 Grand Canal
                            Street Lower, Grand Canal Dock, Dublin, Irland</p>
                        <p>Bei Auswahl einer Zahlungsart des Anbieters, bei der du in
                            Vorleistung gehst (etwa Kreditkartenzahlung), werden an diesen
                            deine im Rahmen des Bestellvorgangs mitgeteilten Zahlungsdaten
                            (darunter Name, Anschrift, Bank- und Zahlkarteninformationen,
                            W&auml;hrung und Transaktionsnummer) sowie
                            Informationen &uuml;ber den Inhalt deiner Bestellung
                            gem&auml;&szlig; Art. 6 Abs. 1 lit. b DSGVO weitergegeben. Die
                            Weitergabe deiner Daten erfolgt in diesem Falle
                            ausschlie&szlig;lich zum Zweck der Zahlungsabwicklung mit dem
                            Anbieter und nur insoweit, als sie hierf&uuml;r erforderlich
                            ist.</p>
                        <p>Bei Auswahl einer Zahlungsart, bei der der Anbieter in
                            Vorleistung geht (etwa Rechnungs- oder Ratenkauf bzw.
                            Lastschrift), wirst du im Bestellablauf auch aufgefordert,
                            bestimmte pers&ouml;nliche Daten (Vor- und Nachname,
                            Stra&szlig;e, Hausnummer, Postleitzahl, Ort, Geburtsdatum,
                            E-Mail-Adresse, Telefonnummer, ggf. Daten zu einem
                            alternativen Zahlungsmittel) anzugeben.</p>
                        <p>Um unser berechtigtes Interesse an der Feststellung der
                            Zahlungsf&auml;higkeit unserer Kunden zu wahren, werden diese
                            Daten von uns gem&auml;&szlig; Art. 6 Abs. 1 lit. f DSGVO zum
                            Zweck einer Bonit&auml;tspr&uuml;fung an den Anbieter
                            weitergeleitet. Der Anbieter pr&uuml;ft auf Basis der von dir
                            angegebenen pers&ouml;nlichen Daten sowie weiterer Daten (wie
                            etwa Warenkorb, Rechnungsbetrag, Bestellhistorie,
                            Zahlungserfahrungen), ob die von dir ausgew&auml;hlte
                            Zahlungsm&ouml;glichkeit im Hinblick auf Zahlungs- und/oder
                            Forderungsausfallrisiken gew&auml;hrt werden kann.</p>
                        <p>Die Bonit&auml;tsauskunft kann Wahrscheinlichkeitswerte
                            enthalten (sog. Score-Werte). Soweit Score-Werte in das
                            Ergebnis der Bonit&auml;tsauskunft einflie&szlig;en, haben sie
                            ihre Grundlage in einem wissenschaftlich anerkannten
                            mathematisch-statistischen Verfahren. In die Berechnung der
                            Score-Werte flie&szlig;en unter anderem, aber nicht
                            ausschlie&szlig;lich, Anschriftendaten ein.</p>
                        <p>Du kannst dieser Verarbeitung deiner Daten jederzeit durch eine
                            Nachricht an uns oder gegen&uuml;ber dem Anbieter
                            widersprechen. Jedoch bleibt der Anbieter ggf. weiterhin
                            berechtigt, deine personenbezogenen Daten zu verarbeiten,
                            sofern dies zur vertragsgem&auml;&szlig;en Zahlungsabwicklung
                            erforderlich ist.</p>
                        <p><b>9.8</b>&nbsp;Elektronische Widerrufsfunktion f&uuml;r
                            Fernabsatzvertr&auml;ge</p>
                        <p>Verbraucher, welche auf dieser Website Vertr&auml;ge
                            schlie&szlig;en, bei denen ein gesetzliches Widerrufsrecht
                            besteht, haben die M&ouml;glichkeit, den Widerruf &uuml;ber
                            eine elektronische Widerrufsfunktion im Einklang mit den
                            geltenden Widerrufsbestimmungen zu erkl&auml;ren.</p>
                        <p>Bei Nutzung der Widerrufsfunktion sind neben Angaben zur
                            Identifizierung des zu widerrufenden Vertrags auch weitere
                            personenbezogene Informationen wie der Vor- und Nachname sowie
                            die Mailadresse des Verbrauchers bereitzustellen oder zu
                            best&auml;tigen.</p>
                        <p>Die Erhebung dieser Informationen und deren &Uuml;bermittlung
                            an uns erfolgt hierbei gem&auml;&szlig; Art. 6 Abs. 1 lit. b
                            DSGVO und nur insoweit, wie sie f&uuml;r die
                            ordnungsgem&auml;&szlig;e Bearbeitung des Widerrufs
                            erforderlich sind. Ebenfalls auf Basis von Art. 6 Abs. 1 lit.
                            b DSGVO werden die bereitgestellten personenbezogenen Daten
                            verwendet, um den Zugang der Widerrufserkl&auml;rung per
                            E-Mail best&auml;tigen. Weitere Rechtsgrundlage f&uuml;r die
                            Verarbeitung ist Art. 6 Abs. 1 lit. c DSGVO. Wir sind zur
                            Vorhaltung einer elektronischen Widerrufsfunktion f&uuml;r
                            entgeltpflichtige Verbraucherfernabsatzvertr&auml;ge
                            gesetzlich verpflichtet.</p>
                        <h2>10) Seitenfunktionalit&auml;ten</h2>
                        <p><b>10.1</b>&nbsp;Facebook Connect</p>
                        <p>Auf unserer Website stellen wir eine Single-Sign-On-Funktion
                            des folgenden Anbieters bereit: Meta Platforms Ireland Ltd., 4
                            Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland.</p>
                        <p>Neben einer &Uuml;bermittlung von Daten an den o.g.
                            Anbieterstandort k&ouml;nnen Daten auch &uuml;bermittelt
                            werden an: Meta Platforms Inc., USA.</p>
                        <p>Wenn du &uuml;ber einen Account beim Anbieter verf&uuml;gst,
                            kannst du dich mit diesen Accountdaten zur Erstellung eines
                            Benutzerkontos bzw. zur Registrierung auf unserer Website
                            anmelden.</p>
                        <p>Beim Besuch dieser Seite kann &uuml;ber diese Anmeldefunktion
                            eine direkte Verbindung zwischen deinem Browser und den
                            Servern des Anbieters hergestellt werden, auch wenn du keinen
                            Account beim Anbieter besitzt oder nicht in einen solchen
                            eingeloggt bist. Der Anbieter erh&auml;lt dadurch die
                            Information, dass du unsere Seite besucht hast. Die insofern
                            erhobenen Informationen (ggf. einschlie&szlig;lich deiner
                            IP-Adresse) werden von deinem Browser direkt an einen Server
                            des Anbieters &uuml;bermittelt und dort gespeichert. Die
                            Informationen werden jedoch nicht dazu verwendet, dich
                            pers&ouml;nlich zu identifizieren, und werden nicht an Dritte
                            weitergegeben.</p>
                        <p>Diese Datenverarbeitungsvorg&auml;nge erfolgen
                            gem&auml;&szlig; Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres
                            berechtigten Interesses an einer nutzerfreundlichen und
                            interaktiven Ausgestaltung unseres Online-Auftritts.</p>
                        <p>Bet&auml;tigst du den Anmeldebutton, um dich mit den Daten
                            deines Accounts beim Anbieter auf unserer Website zu
                            registrieren, &uuml;bermittelt der Anbieter
                            ausschlie&szlig;lich auf Basis deiner ausdr&uuml;cklichen
                            Einwilligung gem&auml;&szlig; Art. 6 Abs. 1 lit. a DSGVO die
                            in deinem Account hinterlegten allgemeinen und &ouml;ffentlich
                            zug&auml;nglichen Informationen (Nutzer-ID, Name, Anschrift,
                            Mailadresse, Alter und Geschlecht) an uns.</p>
                        <p>Wir speichern und verwenden die vom Anbieter &uuml;bermittelten
                            Daten zur Einrichtung eines Benutzerkontos mit den notwendigen
                            Daten (Anrede, Vorname, Nachname, Adressdaten, Land,
                            E-Mail-Adresse, Geburtsdatum), sofern du diese gegen&uuml;ber
                            dem Anbieter freigegeben hast. Umgekehrt k&ouml;nnen auf Basis
                            deiner Einwilligung Daten (z.B. Informationen &uuml;ber dein
                            Surf- oder Kaufverhalten) von uns auf deinen Account beim
                            Anbieter &uuml;bertragen werden.</p>
                        <p>Die erteilte Einwilligung kann jederzeit mit Wirkung f&uuml;r
                            die Zukunft uns gegen&uuml;ber widerrufen werden.</p>
                        <p>F&uuml;r Daten&uuml;bermittlungen in die USA hat sich der
                            Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy
                            Framework) angeschlossen, das auf Basis eines
                            Angemessenheitsbeschlusses der Europ&auml;ischen Kommission
                            die Einhaltung des europ&auml;ischen Datenschutzniveaus
                            sicherstellt.</p>
                        <p><b>10.2</b>&nbsp;Google Sign-In</p>
                        <p>Auf unserer Website stellen wir eine Single-Sign-On-Funktion
                            des folgenden Anbieters bereit: Google Ireland Limited, Gordon
                            House, 4 Barrow St, Dublin, D04 E5W5, Irland.</p>
                        <p>Neben einer &Uuml;bermittlung von Daten an den o.g.
                            Anbieterstandort k&ouml;nnen Daten auch &uuml;bermittelt
                            werden an: Google LLC, USA.</p>
                        <p>Wenn du &uuml;ber einen Account beim Anbieter verf&uuml;gst,
                            kannst du dich mit diesen Accountdaten zur Erstellung eines
                            Benutzerkontos bzw. zur Registrierung auf unserer Website
                            anmelden.</p>
                        <p>Beim Besuch dieser Seite kann &uuml;ber diese Anmeldefunktion
                            eine direkte Verbindung zwischen deinem Browser und den
                            Servern des Anbieters hergestellt werden, auch wenn du keinen
                            Account beim Anbieter besitzt oder nicht in einen solchen
                            eingeloggt bist. Der Anbieter erh&auml;lt dadurch die
                            Information, dass du unsere Seite besucht hast. Die insofern
                            erhobenen Informationen (ggf. einschlie&szlig;lich deiner
                            IP-Adresse) werden von deinem Browser direkt an einen Server
                            des Anbieters &uuml;bermittelt und dort gespeichert. Die
                            Informationen werden jedoch nicht dazu verwendet, dich
                            pers&ouml;nlich zu identifizieren, und werden nicht an Dritte
                            weitergegeben.</p>
                        <p>Diese Datenverarbeitungsvorg&auml;nge erfolgen
                            gem&auml;&szlig; Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres
                            berechtigten Interesses an einer nutzerfreundlichen und
                            interaktiven Ausgestaltung unseres Online-Auftritts.</p>
                        <p>Bet&auml;tigst du den Anmeldebutton, um dich mit den Daten
                            deines Accounts beim Anbieter auf unserer Website zu
                            registrieren, &uuml;bermittelt der Anbieter
                            ausschlie&szlig;lich auf Basis deiner ausdr&uuml;cklichen
                            Einwilligung gem&auml;&szlig; Art. 6 Abs. 1 lit. a DSGVO die
                            in deinem Account hinterlegten allgemeinen und &ouml;ffentlich
                            zug&auml;nglichen Informationen (Nutzer-ID, Name, Anschrift,
                            Mailadresse, Alter und Geschlecht) an uns.</p>
                        <p>Wir speichern und verwenden die vom Anbieter &uuml;bermittelten
                            Daten zur Einrichtung eines Benutzerkontos mit den notwendigen
                            Daten (Anrede, Vorname, Nachname, Adressdaten, Land,
                            E-Mail-Adresse, Geburtsdatum), sofern du diese gegen&uuml;ber
                            dem Anbieter freigegeben hast. Umgekehrt k&ouml;nnen auf Basis
                            deiner Einwilligung Daten (z.B. Informationen &uuml;ber dein
                            Surf- oder Kaufverhalten) von uns auf deinen Account beim
                            Anbieter &uuml;bertragen werden.</p>
                        <p>Die erteilte Einwilligung kann jederzeit mit Wirkung f&uuml;r
                            die Zukunft uns gegen&uuml;ber widerrufen werden.</p>
                        <p>F&uuml;r Daten&uuml;bermittlungen in die USA hat sich der
                            Anbieter dem EU-US-Datenschutzrahmen (EU-US Data Privacy
                            Framework) angeschlossen, das auf Basis eines
                            Angemessenheitsbeschlusses der Europ&auml;ischen Kommission
                            die Einhaltung des europ&auml;ischen Datenschutzniveaus
                            sicherstellt.</p>
                        <p>Weitere Hinweise zum Datenschutz von Google findest du hier: <a
                          href="https://business.safety.google/intl/de/privacy/"
                          target="_blank">https://business.safety.google
                            <wbr/>
                            /intl
                            <wbr/>
                            /de
                            <wbr/>
                            /privacy
                            <wbr/>
                            /</a></p>
                        <p><b>10.3</b>&nbsp;OpenStreetMap</p>
                        <p>Diese Webseite nutzt einen Online-Kartendienst des folgenden
                            Anbieters: OpenStreetMap Foundation, St John&rsquo;s
                            Innovation Centre, Cowley Road, Cambridge, CB4 0WS, UK</p>
                        <p>Der Online-Kartendienst ist ein Tool zur Anzeige interaktiver
                            (Land-)Karten, um geographische Informationen visuell
                            darzustellen. &Uuml;ber die Nutzung dieses Dienstes wird dir
                            unser Standort angezeigt und eine etwaige Geolokalisierung
                            erleichtert.</p>
                        <p>Bereits beim Aufrufen derjenigen Unterseiten, in die die Karte
                            des Anbieters eingebunden ist, werden Informationen &uuml;ber
                            deine Nutzung unserer Webseite (wie z.B. deine IP-Adresse) an
                            Server des Anbieters &uuml;bertragen und dort gespeichert.</p>
                        <p>Die Verarbeitung deiner personenbezogenen Daten erfolgt
                            gem&auml;&szlig; Art. 6 Abs. 1 lit. f DSGVO auf Basis unseres
                            berechtigten Interesses an der bedarfsgerechten Gestaltung
                            unserer Webseite. Wenn du mit der
                            k&uuml;nftigen &Uuml;bermittlung deiner Daten an den Anbieter
                            nicht einverstanden bist, besteht die M&ouml;glichkeit, den
                            Online-Kartendienst des Anbieters vollst&auml;ndig zu
                            deaktivieren, indem du die Anwendung JavaScript in deinem
                            Browser ausschaltest. Der Online-Kartendienst auf dieser
                            Webseite kann dann nicht mehr genutzt werden.</p>
                        <p>Soweit rechtlich erforderlich, haben wir zur vorstehend
                            dargestellten Verarbeitung deiner Daten deine Einwilligung
                            gem&auml;&szlig; Art. 6 Abs. 1 lit. a DSGVO eingeholt. Du
                            kannst deine erteilte Einwilligung jederzeit mit Wirkung
                            f&uuml;r die Zukunft widerrufen. Um deinen Widerruf
                            auszu&uuml;ben, befolge bitte die vorstehend geschilderte
                            M&ouml;glichkeit zur Vornahme eines Widerspruchs.</p>
                        <p>Bei einer Daten&uuml;bermittlung an den Anbieterstandort ist
                            ein angemessenes Datenschutzniveau durch einen
                            Angemessenheitsbeschluss der Europ&auml;ischen Kommission
                            gew&auml;hrleistet.</p>
                        <p><b>10.4</b>&nbsp;- Friendly Captcha</p>
                        <p>Auf dieser Website verwenden wir den CAPTCHA-Dienst des
                            folgenden Anbieters: Friendly Captcha GmbH, Am Anger 3-5,
                            82237 W&ouml;rthsee</p>
                        <p>Der Dienst pr&uuml;ft, ob eine Eingabe durch eine
                            nat&uuml;rliche Person oder missbr&auml;uchlich durch
                            maschinelle und automatisierte Verarbeitung erfolgt, und
                            blockiert Spam, DDoS-Attacken sowie &auml;hnliche
                            automatisierte Schadzugriffe.</p>
                        <p>Wenn du eine Seite unseres Webauftritts aufrufst, die
                            Captcha-Elemente des Anbieters enth&auml;lt, stellt dein
                            Browser eine direkte Verbindung zu den Servern des Anbieters
                            her, um die Elemente ordnungsgem&auml;&szlig; zu laden.
                            Hierbei werden bestimmte Browserinformationen,
                            einschlie&szlig;lich deiner IP-Adresse, an den
                            Anbieter &uuml;bermittelt.</p>
                        <p>Rechtsgrundlage ist unser berechtigtes Interesse an der
                            Feststellung der individuellen Eigenverantwortung im Internet
                            und der Vermeidung von Missbrauch und Spam
                            gem&auml;&szlig; Art. 6 Abs. 1 lit. f DSGVO.</p>
                        <p>Im Anschluss an die &Uuml;bermittlung werden die erhobenen
                            Browser-Informationen automatisch unmittelbar anonymisiert,
                            sodass f&uuml;r die Verifizierung des menschlichen Ursprungs
                            einer Seiteninteraktion keinerlei personenbezogene Daten
                            verarbeitet werden.</p>
                        <p>Wir haben mit dem Anbieter einen Auftragsverarbeitungsvertrag
                            abgeschlossen, der den Schutz der Daten unserer Seitenbesucher
                            sicherstellt und eine unberechtigte Weitergabe an Dritte
                            untersagt.</p>
                        <h2>11) Tools und Sonstiges</h2>
                        <p><b>11.1</b>&nbsp;Billbee</p>
                        <p>F&uuml;r die Erledigung deiner Buchhaltung nutzen wir den
                            Service der cloudbasierten Buchhaltungssoftware des folgenden
                            Anbieters: Billbee GmbH, Arolser Str. 10, 34477 Twistetal,
                            Deutschland.</p>
                        <p>Der Anbieter verarbeitet Eingangs- und Ausgangsrechnungen sowie
                            ggf. auch die Bankbewegungen unseres Unternehmens, um
                            Rechnungen automatisch zu erfassen, zu den Transaktionen zu
                            matchen und hieraus in einem teilautomatisierten Prozess die
                            Finanzbuchhaltung zu erstellen.</p>
                        <p>Sofern hierbei auch personenbezogene Daten verarbeitet werden,
                            erfolgt die Verarbeitung auf Basis unseres berechtigten
                            Interesses an einer effizienten Organisation und Dokumentation
                            unserer Gesch&auml;ftsvorg&auml;nge.</p>
                        <p><b>11.2</b>&nbsp;BuchhaltungsButler</p>
                        <p>F&uuml;r die Erledigung deiner Buchhaltung nutzen wir den
                            Service der cloudbasierten Buchhaltungssoftware des folgenden
                            Anbieters: BuchhaltungsButler GmbH, Ausbau 1, 15910
                            Unterspreewald, Deutschland</p>
                        <p>Der Anbieter verarbeitet Eingangs- und Ausgangsrechnungen sowie
                            ggf. auch die Bankbewegungen unseres Unternehmens, um
                            Rechnungen automatisch zu erfassen, zu den Transaktionen zu
                            matchen und hieraus in einem teilautomatisierten Prozess die
                            Finanzbuchhaltung zu erstellen.</p>
                        <p>Sofern hierbei auch personenbezogene Daten verarbeitet werden,
                            erfolgt die Verarbeitung auf Basis unseres berechtigten
                            Interesses an einer effizienten Organisation und Dokumentation
                            unserer Gesch&auml;ftsvorg&auml;nge.</p>
                        <p><b>11.3</b>&nbsp;Cookie-Consent-Tool</p>
                        <p>Diese Website nutzt zur Einholung wirksamer
                            Nutzereinwilligungen f&uuml;r einwilligungspflichtige Cookies
                            und cookie-basierte Anwendungen ein
                            sog. &bdquo;Cookie-Consent-Tool&#8220;.
                            Das &bdquo;Cookie-Consent-Tool&#8220; wird dir bei
                            Seitenaufruf in Form einer interaktiven
                            Benutzeroberfl&auml;che angezeigt, auf welcher du per
                            H&auml;kchensetzung Einwilligungen f&uuml;r bestimmte Cookies
                            und/oder cookie-basierte Anwendungen erteilen kannst. Hierbei
                            werden durch den Einsatz des Tools alle
                            einwilligungspflichtigen Cookies/Dienste nur dann geladen,
                            wenn du entsprechende Einwilligungen per H&auml;kchensetzung
                            erteilst. So wird sichergestellt, dass nur im Falle einer
                            erteilten Einwilligung derartige Cookies auf deinem jeweiligen
                            Endger&auml;t gesetzt werden.</p>
                        <p>Das Tool setzt technisch notwendige Cookies, um deine
                            Cookie-Pr&auml;ferenzen zu speichern. Personenbezogene
                            Nutzerdaten werden hierbei grunds&auml;tzlich nicht
                            verarbeitet.</p>
                        <p>Kommt es im Einzelfall zum Zwecke der Speicherung, Zuordnung
                            oder Protokollierung von Cookie-Einstellungen doch zur
                            Verarbeitung personenbezogener Daten (wie etwa der
                            IP-Adresse), erfolgt diese gem&auml;&szlig; Art. 6 Abs. 1 lit.
                            f DSGVO auf Basis unseres berechtigten Interesses an einem
                            rechtskonformen, nutzerspezifischen und nutzerfreundlichen
                            Einwilligungsmanagement f&uuml;r Cookies und mithin an einer
                            rechtskonformen Ausgestaltung unseres Internetauftritts.</p>
                        <p>Weitere Rechtsgrundlage f&uuml;r die Verarbeitung ist ferner
                            Art. 6 Abs. 1 lit. c DSGVO. Wir unterliegen als
                            Verantwortliche der rechtlichen Verpflichtung, den Einsatz
                            technisch nicht notwendiger Cookies von der jeweiligen
                            Nutzereinwilligung abh&auml;ngig zu machen.</p>
                        <p>Soweit erforderlich, haben wir mit dem Anbieter einen
                            Auftragsverarbeitungsvertrag geschlossen, der den Schutz der
                            Daten unserer Seitenbesucher sicherstellt und eine
                            unberechtigte Weitergabe an Dritte untersagt.</p>
                        <p>Weitere Informationen zum Betreiber und den
                            Einstellungsm&ouml;glichkeiten des Cookie-Consent-Tools
                            findest du direkt in der entsprechenden
                            Benutzeroberfl&auml;che auf unserer Website.</p>
                        <h2>12) Rechte des Betroffenen</h2>
                        <p><b>12.1</b>&nbsp;Das geltende Datenschutzrecht gew&auml;hrt dir
                            gegen&uuml;ber uns als Verantwortlichen hinsichtlich der
                            Verarbeitung deiner personenbezogenen Daten die nachstehenden
                            Betroffenenrechte (Auskunfts- und Interventionsrechte), wobei
                            f&uuml;r die jeweiligen Aus&uuml;bungsvoraussetzungen auf die
                            angef&uuml;hrte Rechtsgrundlage verwiesen wird:</p>
                        <ul>
                            <li>Auskunftsrecht gem&auml;&szlig; Art. 15 DSGVO;</li>
                            <li>Recht auf Berichtigung gem&auml;&szlig; Art. 16 DSGVO;
                            </li>
                            <li>Recht auf L&ouml;schung gem&auml;&szlig; Art. 17 DSGVO;
                            </li>
                            <li>Recht auf Einschr&auml;nkung der Verarbeitung
                                gem&auml;&szlig; Art. 18 DSGVO;
                            </li>
                            <li>Recht auf Unterrichtung gem&auml;&szlig; Art. 19 DSGVO;
                            </li>
                            <li>Recht auf Daten&uuml;bertragbarkeit gem&auml;&szlig; Art.
                                20 DSGVO;
                            </li>
                            <li>Recht auf Widerruf erteilter Einwilligungen
                                gem&auml;&szlig; Art. 7 Abs. 3 DSGVO;
                            </li>
                            <li>Recht auf Beschwerde gem&auml;&szlig; Art. 77 DSGVO.</li>
                        </ul>
                        <p><b>12.2</b>&nbsp;WIDERSPRUCHSRECHT</p>
                        <p>WENN WIR IM RAHMEN EINER INTERESSENABW&Auml;GUNG DEINE
                            PERSONENBEZOGENEN DATEN AUFGRUND UNSERES &Uuml;BERWIEGENDEN
                            BERECHTIGTEN INTERESSES VERARBEITEN, HAST DU DAS JEDERZEITIGE
                            RECHT, AUS GR&Uuml;NDEN, DIE SICH AUS DEINER BESONDEREN
                            SITUATION ERGEBEN, GEGEN DIESE VERARBEITUNG WIDERSPRUCH MIT
                            WIRKUNG F&Uuml;R DIE ZUKUNFT EINZULEGEN.</p>
                        <p>MACHST DU VON DEINEM WIDERSPRUCHSRECHT GEBRAUCH, BEENDEN WIR
                            DIE VERARBEITUNG DER BETROFFENEN DATEN. EINE
                            WEITERVERARBEITUNG BLEIBT ABER VORBEHALTEN, WENN WIR ZWINGENDE
                            SCHUTZW&Uuml;RDIGE GR&Uuml;NDE F&Uuml;R DIE VERARBEITUNG
                            NACHWEISEN K&Ouml;NNEN, DIE DEINE INTERESSEN, GRUNDRECHTE UND
                            GRUNDFREIHEITEN &Uuml;BERWIEGEN, ODER WENN DIE VERARBEITUNG
                            DER GELTENDMACHUNG, AUS&Uuml;BUNG ODER VERTEIDIGUNG VON
                            RECHTSANSPR&Uuml;CHEN DIENT.</p>
                        <p>WERDEN DEINE PERSONENBEZOGENEN DATEN VON UNS VERARBEITET, UM
                            DIREKTWERBUNG ZU BETREIBEN, HAST DU DAS RECHT, JEDERZEIT
                            WIDERSPRUCH GEGEN DIE VERARBEITUNG DIR BETREFFENDER
                            PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG
                            EINZULEGEN. DU KANNST DEN WIDERSPRUCH WIE OBEN BESCHRIEBEN
                            AUS&Uuml;BEN.</p>
                        <p>MACHST DU VON DEINEM WIDERSPRUCHSRECHT GEBRAUCH, BEENDEN WIR
                            DIE VERARBEITUNG DER BETROFFENEN DATEN ZU
                            DIREKTWERBEZWECKEN.</p>
                        <h2>13) Dauer der Speicherung personenbezogener Daten</h2>
                        <p>Die Dauer der Speicherung von personenbezogenen Daten bemisst
                            sich anhand der jeweiligen Rechtsgrundlage, am
                            Verarbeitungszweck und &ndash; sofern
                            einschl&auml;gig &ndash; zus&auml;tzlich anhand der jeweiligen
                            gesetzlichen Aufbewahrungsfrist (z.B. handels- und
                            steuerrechtliche Aufbewahrungsfristen).</p>
                        <p>Bei der Verarbeitung von personenbezogenen Daten auf Grundlage
                            einer ausdr&uuml;cklichen Einwilligung gem&auml;&szlig; Art. 6
                            Abs. 1 lit. a DSGVO werden die betroffenen Daten so lange
                            gespeichert, bis du deine Einwilligung widerrufst.</p>
                        <p>Existieren gesetzliche Aufbewahrungsfristen f&uuml;r Daten, die
                            im Rahmen rechtsgesch&auml;ftlicher bzw.
                            rechtsgesch&auml;fts&auml;hnlicher Verpflichtungen auf der
                            Grundlage von Art. 6 Abs. 1 lit. b DSGVO verarbeitet werden,
                            werden diese Daten nach Ablauf der Aufbewahrungsfristen
                            routinem&auml;&szlig;ig gel&ouml;scht, sofern sie nicht mehr
                            zur Vertragserf&uuml;llung oder Vertragsanbahnung erforderlich
                            sind und/oder unsererseits kein berechtigtes Interesse an der
                            Weiterspeicherung fortbesteht.</p>
                        <p>Bei der Verarbeitung von personenbezogenen Daten auf Grundlage
                            von Art. 6 Abs. 1 lit. f DSGVO werden diese Daten so lange
                            gespeichert, bis du dein Widerspruchsrecht nach Art. 21 Abs. 1
                            DSGVO aus&uuml;bst, es sei denn, wir k&ouml;nnen zwingende
                            schutzw&uuml;rdige Gr&uuml;nde f&uuml;r die Verarbeitung
                            nachweisen, die deine Interessen, Rechte und
                            Freiheiten &uuml;berwiegen, oder die Verarbeitung dient der
                            Geltendmachung, Aus&uuml;bung oder Verteidigung von
                            Rechtsanspr&uuml;chen.</p>
                        <p>Bei der Verarbeitung von personenbezogenen Daten zum Zwecke der
                            Direktwerbung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
                            werden diese Daten so lange gespeichert, bis du dein
                            Widerspruchsrecht nach Art. 21 Abs. 2 DSGVO aus&uuml;bst.</p>
                        <p>Sofern sich aus den sonstigen Informationen dieser
                            Erkl&auml;rung &uuml;ber spezifische Verarbeitungssituationen
                            nichts anderes ergibt, werden gespeicherte personenbezogene
                            Daten im &Uuml;brigen dann gel&ouml;scht, wenn sie f&uuml;r
                            die Zwecke, f&uuml;r die sie erhoben oder auf sonstige Weise
                            verarbeitet wurden, nicht mehr notwendig sind.</p></div>
                    <div style={{ marginTop: '3rem', }}>
                        <div style={{
                            display: 'inline-block',
                            verticalAlign: 'top',
                        }}><a
                          href="https://www.it-recht-kanzlei.de/" target="_blank"><img
                          src="https://www.it-recht-kanzlei.de/logo/Copyright-Logo_Datenschutzerklaerung.png?i=334dc-19c5e-39c8-907e-1"
                          id="itkanzlei_img_copyright" alt="&copy; IT-Recht Kanzlei"
                          title="&copy; IT-Recht Kanzlei"
                          style={{
                              marginTop: '-20px',
                              borderStyle: 'none',
                              maxWidth: '100%',
                          }}/></a></div>
                        <div
                          style={{
                              display: 'inline-block',
                              verticalAlign: 'top',
                              marginLeft: '5px',
                              float: 'right',
                              whiteSpace: 'nowrap',
                          }}>Stand:
                            18.06.2026, 12:13:03
                        </div>
                        <div style={{ clear: 'right' }}></div>
                    </div>

                </ContentWrapper>
            </article>
        </React.Fragment>
    );
};
export default Privacy;



// WEBPACK FOOTER //
// ./src/components/de/Privacy.js